import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=0e0a5e88&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e0a5e88')) {
      api.createRecord('0e0a5e88', component.options)
    } else {
      api.reload('0e0a5e88', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=0e0a5e88&", function () {
      api.rerender('0e0a5e88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21g3Gvq3imkY8/JS/comp/FavElement.vue"
export default component.exports